import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { GET_EXPENSE_CATEGORIES_OF_TYPE } from "../graphql/expenseCategory";
import ExpenseCategoryType from "../enums/ExpenseCategoryType";
import { ExpenseCategory } from "../components/common/CategorySearchAutoComplete";

export const useAccountCategories = () => {
  const { data: categories, refetch: refetchAccountCategories } = useQuery(
    GET_EXPENSE_CATEGORIES_OF_TYPE,
    {
      variables: { type: ExpenseCategoryType.ACCOUNT },
    },
  );
  const [accountCategories, setAccountCategories] = useState<ExpenseCategory[]>(
    [],
  );

  useEffect(() => {
    if (categories) {
      setAccountCategories(categories.expenseCategories);
    }
  }, [categories]);

  return { accountCategories, refetchAccountCategories };
};
